import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const titles = {
  '/dashboard': 'Dashboard',
  '/attendance': 'Attendance',
  '/people': 'People Directory',
  '/touchpoint': 'Touchpoint',
  '/prayer': 'Prayer',
  '/reports': 'Reports',
  '/settings': 'Settings',
};

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const basePath = '/' + (location.pathname.split('/')[1] || 'dashboard');
  const title = titles[basePath] || 'Pastoral Pulse';

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="lg:ml-64">
        <Header onMenuClick={() => setSidebarOpen(true)} title={title} />
        <main className="p-4 sm:p-6">{children}</main>
      </div>
    </div>
  );
}
